/*
 * ─────────────────────────────────────────────────────────────────────────────
 * VECCHI FILE GESTIONE CORSI — sostituiti dalla gestione in
 * src/jsx/pages/struttura/corsi/. Non sono più raggiungibili dal menu: restano
 * solo per gli indirizzi diretti, finché non si decide di eliminarli.
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Button, Spinner, Form } from "react-bootstrap";
import chiediConferma from '../../../../components/Util/chiediConferma';
import { DocumentText, DollarSquare, CardAdd, Judge} from "iconsax-react";
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { sports, italianProvinces, tipologiaStruttura } from "../../../../components/Util/enum";
import { format } from 'date-fns';
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { useProfile } from "../../../../../hooks/useProfile";
import { saveSaleDraft, loadSaleDraft, clearSaleDraft } from "../../../../components/Util/saleDraft";
import { numeroDaTesto } from "../../../../components/Util/prezzi";
import { segnalaMancanti } from "../../../../components/Util/campiMancanti";

// Campi obbligatori vuoti o scritti male (regola «Dati mancanti»): niente finestre né tooltip del browser,
// si evidenziano i campi con cosa manca.
const campiNonValidi = (form) => {
    const lista = [];
    Array.from(form.elements).forEach((el, i) => {
        if (!el.willValidate || el.checkValidity()) return;
        if (!el.id) el.id = `campo-${el.name || 'richiesto'}-${i}`;
        let etichetta = '';
        for (let p = el.parentElement, n = 0; p && n < 5 && !etichetta; p = p.parentElement, n += 1) {
            const l = p.querySelectorAll('label');
            if (l.length === 1) etichetta = l[0].textContent.replace(/\s*\*+\s*$/, '').trim();
            else if (l.length > 1) break;
        }
        const messaggio = el.validity.valueMissing || !el.validationMessage
            ? (etichetta ? `Manca il campo «${etichetta}»` : 'Dato mancante')
            : el.validationMessage;
        lista.push({ campo: el, messaggio });
    });
    return lista;
};

export const UserCoursesNew = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const formRefs = useRef({});
	const [loadingShowed, setLoadingShowed] = useState(false);
    const [courses, setCourses] = useState([]);
    const [juniors, setJuniors] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [userSearchInput, setUserSearchInput] = useState("");
    const [isForJunior, setIsForJunior] = useState(false);
    const [termsAndConditions, setTermsAndConditions] = useState(false);
    const [termsAndConditionsMarketing, setTermsAndConditionsMarketing] = useState(false);
    const [termsAndConditionsImage, setTermsAndConditionsImage] = useState(false);
    const [formData, setFormData] = useState({
        prezzo_praticato: '',
        playerId: '', 
        juniorId: '',
        course_id: '',
        course_name: '',
        course_price: '',
        dateStart: '',
        dateEnd: '',
        isMember: '',
        isFederated: '',
        corso_user: '',
        corso_user_junior: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        is_pagato: false,
        modalita_pagamento: '',
        skip_generate_document: false,
        expiration_type: '',
        sportType: ''
    });

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ];

    const optionsPayment = [
        { value: "CASH", label: "Contanti" },
        { value: "CARD", label: "Carta di credito" },
        { value: "BANK_TRANSFER", label: "Bonifico" }
    ];

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ];
    
    const optionsGenerateDocument = [
        { value: false, label: "Si" },
        { value: true, label: "No" }
    ];

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const { profile, loading: profileLoading } = useProfile();
    const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';

    useEffect(() => {
        if (!profileLoading && profile && !isFatturazioneConfirmed && formData.skip_generate_document !== true) {
            setFormData(prev => ({ ...prev, skip_generate_document: true }));
        }
    }, [profileLoading, profile, isFatturazioneConfirmed, formData.skip_generate_document]);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const coursesApi = await apiClient.getBookingCourses(token);
                    setLoadingShowed(false);

                    let courseOptions = []
                    if(coursesApi) {
                        coursesApi.forEach(element => {
                            if(element.status === 'PURCHASABLE') {
                                courseOptions.push({ 
                                    value: element.id, 
                                    label: element.name, 
                                    sportType: element.sportType, 
                                    expiration_type: element.expiration_type,
                                    standard_price: element.standard_price+' €',
                                    member_price: element.member_price+' €',
                                    federated_price: element.federated_price+' €',
                                })
                            }
                        });
                    }
                    setCourses(courseOptions);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value) {
                setShowingSociOptions(true);
            }
            if(tokenDetails.clubNature === tipologiaStruttura.ASD.value || tokenDetails.clubNature === tipologiaStruttura.SSD.value) {
                setShowingTesseratiOptions(true);
            }
        }
    }, []);

    // Auto-selezione del corso se presente nell'URL
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const courseId = urlParams.get('courseId');
        
        if (courseId && courses.length > 0) {
            // Timeout per simulare il click dell'utente dopo che tutto è caricato
            setTimeout(() => {
                const courseToSelect = courses.find(course => course.value === courseId);
                if (courseToSelect) {
                    handleSelectChange(courseToSelect, 'course_id');
                }
            }, 1000); // 1 secondo di delay
        }
    }, [courses, location.search]);

    const goBack = (numOfTab) => {
        if(numOfTab>-1) {
            setTabIndex(numOfTab);
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
        } else {
            navigate('/struttura/booking/courses');
        }
	};

    // Funzione per la ricerca asincrona degli utenti per il componente Select unificato
    const loadUserOptions = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const playersData = await apiClient.getProfilesByFilters(token, 10000, inputValue, 'IDS_PLAY');

                if (playersData && playersData.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante la lettura (" + playersData.error + ")");
                    setModalShowed(true);
                    return [];
                } else {
                    const playerOptions = playersData.items.map(element => ({
                        value: element.userId,
                        label: element.name
                    }));
                    return playerOptions;
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            return [];
        }
        return [];
    };

    // Gestisce la selezione dell'utente dal componente Select unificato
    const handleUserSelect = (selectedOption) => {
        setSelectedUser(selectedOption);
        setFormData(prev => ({
            ...prev,
            playerId: selectedOption ? selectedOption.value : ''
        }));
    };

    // "Crea nuovo cliente" → pagina completa di creazione, poi ritorno qui col cliente selezionato.
    // Snapshot di tutto ciò che l'utente ha inserito, per ripristinarlo al ritorno.
    const buildDraft = () => ({
        formData,
        selectedUser,
        isForJunior,
        userSearchInput,
        termsAndConditions,
        termsAndConditionsMarketing,
        termsAndConditionsImage,
        showingSociOptions,
        showingTesseratiOptions,
    });

    const goCreateNewCustomer = () => {
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        const clean = params.toString();
        const back = location.pathname + (clean ? `?${clean}` : '');
        navigate(`/struttura/clienti/nuovo?returnTo=${encodeURIComponent(back)}`);
    };

    // Al ritorno dalla creazione: ripristina il form e pre-seleziona cliente/junior.
    useEffect(() => {
        const newCustomerId = searchParams.get('newCustomerId');
        const newCustomerName = searchParams.get('newCustomerName');
        const newJuniorId = searchParams.get('newJuniorId');
        const returning = !!(newCustomerId || newJuniorId);
        const draft = returning ? loadSaleDraft(location.pathname) : null;
        clearSaleDraft(location.pathname);

        if (draft) {
            if (draft.formData) setFormData(draft.formData);
            if (draft.selectedUser) setSelectedUser(draft.selectedUser);
            setIsForJunior(!!draft.isForJunior);
            setUserSearchInput(draft.userSearchInput || '');
            setTermsAndConditions(!!draft.termsAndConditions);
            setTermsAndConditionsMarketing(!!draft.termsAndConditionsMarketing);
            setTermsAndConditionsImage(!!draft.termsAndConditionsImage);
            setShowingSociOptions(!!draft.showingSociOptions);
            setShowingTesseratiOptions(!!draft.showingTesseratiOptions);
        }

        if (newCustomerId) {
            handleUserSelect({ value: newCustomerId, label: newCustomerName || (draft && draft.selectedUser && draft.selectedUser.label) || 'Cliente' });
            if (newJuniorId) {
                setIsForJunior(true);
                fetchJuniorsFor(newCustomerId).then(list => {
                    setJuniors(list);
                    setFormData(prev => ({ ...prev, juniorId: newJuniorId }));
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : (selectedOption ? selectedOption.value : '');
    
        setFormData(prev => {
            const newData = {
                ...prev,
                [name]: selectedValue,
            };
            
            // Se is_pagato viene impostato su false, resetta anche skip_generate_document
            if (name === 'is_pagato' && !selectedValue) {
                newData.skip_generate_document = (profile && !isFatturazioneConfirmed) ? true : false;
            }
            
            return newData;
        });
    };

    useEffect(() => {
        if ((formData.course_id && formData.playerId)) {
            const course = courses.find(sub => sub.value === formData.course_id);
            if (course) {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();
    
                    setLoadingShowed(true);
                    apiClient.getUserBookingCoursesPreview(token, formData.playerId, null, course.value).then(coursePreview => {
                        setLoadingShowed(false);
    
                        setFormData(prev => ({
                            ...prev,
                            sportType: course.sportType,
                            expiration_type: course.expiration_type,
                            course_name: course.label,
                            course_price: coursePreview.data.coursePrice + " €",
                            prezzo_praticato: coursePreview.data.coursePrice,
                            isMember: coursePreview.data.isMember ? 'Si' : 'No',
                            isFederated: coursePreview.data.isFederated ? 'Si' : 'No',
                            dateStart: coursePreview.data.startDate
                                ? coursePreview.data.startDate.substring(8, 10) + '/' +
                                    coursePreview.data.startDate.substring(5, 7) + '/' +
                                    coursePreview.data.startDate.substring(0, 4)
                                : '',
                            dateEnd: coursePreview.data.endDate
                                ? coursePreview.data.endDate.substring(8, 10) + '/' +
                                    coursePreview.data.endDate.substring(5, 7) + '/' +
                                    coursePreview.data.endDate.substring(0, 4)
                                : '',
                        }));
                    });
                }
            }
        }
    }, [formData.course_id, formData.playerId, courses]);

    const handleCheckboxChangeTermsAndConditions = (event) => {
        setTermsAndConditions(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsMarketing = (event) => {
        setTermsAndConditionsMarketing(event.target.checked);
    };

    const handleCheckboxChangeTermsAndConditionsImage = (event) => {
        setTermsAndConditionsImage(event.target.checked);
    };

    // Carica i junior di un cliente (parent) e li mappa per la Lista Juniors.
    const fetchJuniorsFor = async (playerId) => {
        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (!tokenDetailsString) return [];
            const token = JSON.parse(tokenDetailsString).idToken;
            const apiClient = new MyApiClient();
            const juniorsData = await apiClient.getJuniorsByParent(token, playerId);
            const data = [];
            if (juniorsData) {
                juniorsData.forEach(element => {
                    let status = null;
                    if (element.profileStatus === 'INACTIVE') status = { label: 'Inattivo', class: 'text-danger' };
                    else if (element.profileStatus === 'ACTIVE') status = { label: 'Attivo', class: 'text-warning' };
                    else if (element.profileStatus === 'COMPLETED') status = { label: 'Completato', class: 'text-success' };
                    data.push({
                        registration_date: format(element.createdAt, 'dd/MM/yyyy HH:mm:ss'),
                        id: element.userId,
                        nome: element.givenName,
                        cognome: element.familyName,
                        status_label: status,
                    });
                });
            }
            return data;
        } catch (error) {
            console.error('Error fetching juniors:', error);
            return [];
        }
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsForJunior(checked);
        if (checked && formData.playerId !== '') {
            setLoadingShowed(true);
            fetchJuniorsFor(formData.playerId).then(list => {
                setLoadingShowed(false);
                setJuniors(list);
            });
        } else {
            setIsForJunior(false);
            setJuniors([]);
            setFormData(prev => ({ ...prev, juniorId: '' }));
        }
    };

    // "Aggiungi Junior" → pagina di creazione junior (parent = cliente selezionato), poi ritorno qui col junior selezionato.
    const goCreateNewJunior = () => {
        if (!formData.playerId) return;
        saveSaleDraft(location.pathname, buildDraft());
        const params = new URLSearchParams(location.search);
        ['newCustomerId', 'newCustomerName', 'newJuniorId', 'newJuniorName'].forEach(k => params.delete(k));
        params.set('newCustomerId', formData.playerId);
        params.set('newCustomerName', selectedUser?.label || '');
        const back = location.pathname + '?' + params.toString();
        const pName = selectedUser?.label || '';
        navigate(`/struttura/junior/nuovo?parentId=${encodeURIComponent(formData.playerId)}&parentName=${encodeURIComponent(pName)}&returnTo=${encodeURIComponent(back)}`);
    };

    const juniors_data_column = [
        {
            Header: 'Nome e cognome',
            accessor: 'name',
            Cell: ({ row }) => {
                return (
                    row.original.nome + ' ' + row.original.cognome
                )
            }
        },
        {
            Header: 'Data registrazione',
            accessor: 'registration_date'
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'status_label',
            Cell: ({ value }) => {
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
                        {value?value.label:''}
                    </div>
                )
            },
            disableFilters: true,
        },
        {
            Header: 'Azione',
            Footer: 'Azione',
            accessor: 'azione',
            Cell: ({ row }) => {
                const isChecked = formData.juniorId === row.original.id;
        
                return (
                    <input
                        type="checkbox"
                        name="selectRow"
                        checked={isChecked}
                        onChange={() => {
                            setFormData(prev => ({
                                ...prev,
                                juniorId: isChecked ? '' : row.original.id,
                                corso_user_junior: isChecked ? '' : row.original.nome + ' ' + row.original.cognome
                            }));
                        }}
                    />
                );
            },
            disableFilters: true,
        }
    ];

    const handleSaveClick = (numOfTab, status) => {
        const form = formRefs.current[tabIndex];
        if(numOfTab<4) {
            if (form) {
                const daSegnalare = [];
                if(numOfTab === 1) {
                    if(isForJunior && formData.juniorId === '') {
                        daSegnalare.push({ campo: 'junior-lista', messaggio: 'Manca lo junior: sceglilo dalla lista' });
                    }
                }
                if(numOfTab === 3) {
                    for (const element of form.elements) {
                        
                        // Controllo Partita IVA
                        if (element.name === "partita_iva") {
                            if (element.value) {
                                if (element.value.length !== 11 || isNaN(element.value)) {
                                    element.setCustomValidity("La partita IVA deve contenere esattamente 11 cifre numeriche.");
                                } else {
                                    element.setCustomValidity("");
                                }
                            } else {
                                element.setCustomValidity("");
                            }
                        }

                        // Controllo Codice Fiscale
                        if (element.name === "codice_fiscale") {
                            if (element.value) {
                                const cfRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
                                if (element.value.length === 16 && cfRegex.test(element.value)) {
                                    element.setCustomValidity("");
                                } else if (element.value.length === 11 && !isNaN(element.value)) {
                                    element.setCustomValidity("");
                                } else {
                                    element.setCustomValidity("Controlla il formato del codice fiscale (16 caratteri) o della partita IVA (11 cifre)");
                                }
                            } else {
                                element.setCustomValidity("");
                            }
                        }
                    }
                }

                if (segnalaMancanti([...daSegnalare, ...campiNonValidi(form)]) === 0) {
                    if(numOfTab === 1) {
                        const tokenDetailsString = sessionStorage.getItem('userDetails');
                        if (tokenDetailsString) {
                            const tokenDetails = JSON.parse(tokenDetailsString);
                            const token = tokenDetails.idToken;
                            const apiClient = new MyApiClient();

                            setLoadingShowed(true);
                            apiClient.getUserBookingCoursesPreview(token, formData.playerId, formData.juniorId, formData.course_id).then(coursePreview => {
                                setLoadingShowed(false);

                                setFormData(prev => ({
                                    ...prev,
                                    course_price: coursePreview.data.coursePrice + " €",
                                    prezzo_praticato: coursePreview.data.coursePrice,
                                    isMember: coursePreview.data.isMember?'Si':'No',
                                    isFederated: coursePreview.data.isFederated?'Si':'No',
                                    dateStart: coursePreview.data.startDate ? 
                                        coursePreview.data.startDate.substring(8, 10) + '/' + 
                                        coursePreview.data.startDate.substring(5, 7) + '/' + 
                                        coursePreview.data.startDate.substring(0, 4) : '',
                                    dateEnd: coursePreview.data.endDate ? 
                                        coursePreview.data.endDate.substring(8, 10) + '/' + 
                                        coursePreview.data.endDate.substring(5, 7) + '/' + 
                                        coursePreview.data.endDate.substring(0, 4) : '',
                                    corso_user: selectedUser ? selectedUser.label : ''
                                }));

                                if(coursePreview.data.receiver) {
                                    formData.codice_fiscale = coursePreview.data.receiver.tax_code;
                                    formData.email = coursePreview.data.receiver.pec || '';
                                    // Fallback: se il receiver non ha PEC/email, precompila l'email dal profilo cliente
                                    if (!formData.email) {
                                        apiClient.getProfiles(token, formData.playerId).then(playerProfile => {
                                            if (playerProfile && !playerProfile.error && playerProfile.idsPlay && playerProfile.idsPlay.email) {
                                                setFormData(prev => ({ ...prev, email: prev.email || playerProfile.idsPlay.email }));
                                            }
                                        });
                                    }
                                    formData.indirizzo = coursePreview.data.receiver.address;
                                    formData.cap = coursePreview.data.receiver.zip_code;
                                    formData.citta = coursePreview.data.receiver.city;
                                    formData.provincia = coursePreview.data.receiver.province;
                                    if(coursePreview.data.receiver.type === 'consumer') {
                                        formData.tipo_cliente = 'privato';
                                        formData.nome = coursePreview.data.receiver.first_name;
                                        formData.cognome = coursePreview.data.receiver.last_name;
                                    } else if(coursePreview.data.receiver.type === 'business') {
                                        formData.tipo_cliente = 'azienda';
                                        formData.ragione_sociale = coursePreview.data.receiver.denomination;
                                        formData.partita_iva = coursePreview.data.receiver.vat_number;
                                        formData.codice_destinatario = coursePreview.data.receiver.sdi_code;
                                    }
                                } else {
                                    // Nessun dato di fatturazione salvato: pre-compiliamo
                                    // nome, cognome ed email dal profilo del cliente.
                                    apiClient.getProfiles(token, formData.playerId).then(playerProfile => {
                                        if (playerProfile && !playerProfile.error) {
                                            const ids = playerProfile.idsPlay || {};
                                            const addr = ids.address || {};
                                            setFormData(prev => ({
                                                ...prev,
                                                tipo_cliente: prev.tipo_cliente || 'privato',
                                                nome: prev.nome || ids.givenName || '',
                                                cognome: prev.cognome || ids.familyName || '',
                                                email: prev.email || ids.email || '',
                                                indirizzo: prev.indirizzo || addr.streetAddress || '',
                                                cap: prev.cap || addr.postalCode || '',
                                                citta: prev.citta || addr.locality || '',
                                                provincia: prev.provincia || addr.province || '',
                                            }));
                                        }
                                    });
                                }

                                setTabIndex(numOfTab);
                                setTimeout(() => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }, 100);
                            });
                        }
                    } else if(numOfTab === 3) {
                        // TODO controlli custom dati fatturazione
                        setTabIndex(numOfTab);
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }, 100);
                    } else {
                        setTabIndex(numOfTab);
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }, 100);
                    }
                }
            }
        } else {
            if(segnalaMancanti([!termsAndConditions && { campo: 'accetta-termini', messaggio: 'Il cliente deve accettare i termini e condizioni della struttura' }].filter(Boolean)) > 0) {
                return;
            }
            
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                formData.clubId = tokenDetails.localId;
                formData.status = status;
                saveConfirm();
            }
        }
    };

    const saveConfirm = () => {
		chiediConferma({ titolo: 'Confermare l\'acquisto?', testo: 'L\'acquisto sarà effettivo solo quando risulta pagato.', conferma: 'Conferma', variante: 'primary' })
		    .then((ok) => { if (ok) saveData(); });
    };

    const saveData = async () => {


        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                let token = tokenDetails.idToken;
                const apiClient = new MyApiClient();

                const userConsents = [];
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'PHOTO_USAGE_BY_STRUCTURE',
                    consent: termsAndConditionsMarketing
                });
                userConsents.push({
                    playerId: formData.playerId,
                    juniorId: formData.juniorId !== '' ? formData.juniorId :  undefined,
                    clubId: tokenDetails.localId,
                    consentType: 'MARKETING_BY_STRUCTURE',
                    consent: termsAndConditionsImage
                });

                const saveData = {
                    playerId: formData.playerId,
                    course_id: formData.course_id,
                    price: formData.prezzo_praticato === '' ? undefined : numeroDaTesto(formData.prezzo_praticato),
                    userConsents: userConsents
                }

                if(formData.juniorId) saveData.juniorId = formData.juniorId;
                if(formData.is_pagato && formData.modalita_pagamento) {
                    saveData.payment_method = formData.modalita_pagamento;
                    saveData.paymentDate = new Date().toISOString().slice(0, 10);
                }
                if(formData.skip_generate_document) {
                    saveData.skip_generate_document = true;
                }

                const dati_fatturazione = {
                    tax_code: formData.codice_fiscale,
                    pec: formData.email,
                    address: formData.indirizzo,
                    zip_code: formData.cap,
                    city: formData.citta,
                    province: formData.provincia,
                    nation: 'IT',
                    country_code: 'IT',
                }
                if(formData.tipo_cliente === 'privato') {
                    dati_fatturazione.type = 'consumer';
                    dati_fatturazione.first_name = formData.nome;
                    dati_fatturazione.last_name = formData.cognome;
                } else if(formData.tipo_cliente === 'azienda') {
                    dati_fatturazione.type = 'business';
                    dati_fatturazione.denomination = formData.ragione_sociale;
                    dati_fatturazione.vat_number = formData.partita_iva;
                    dati_fatturazione.sdi_code = formData.codice_destinatario;
                }

                saveData.receiver = dati_fatturazione;

                setLoadingShowed(true);
                const result = await apiClient.createUserBookingCourse(token, saveData);
                setLoadingShowed(false);

                if(result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText(result.error);
                    setModalShowed(true);
                } else {
                    navigate('/struttura/booking/sales');
                }
            }
        } catch (error) {
            console.error('Error in MyApiClient: '+error);
            if (error.response) {
                const errorResponseData = error.response.data;
                console.log('Error response data:', errorResponseData.detail);
                return {'error': errorResponseData.detail};
            } else {
                return {'error': 'Errore generico'};
            }
        }   
    }

	const tabData = [
		{
			id: 'informazioni_generali',
			name: "Informazioni generali",
			icon: <i className="fas fa-info-circle me-2"></i>,
			content: (
                <>
                    <Card>
                        <Card.Header><h4 className="card-title">Nuova vendita corso</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[0] = el} noValidate>
                                <Row>
									<Col className="col-lg-12">
										<Form.Label>Cerca e seleziona un utente di SportId *</Form.Label>
                                        <div className="mb-2">
                                            <Button variant="link" className="p-0" style={{ fontSize: "0.9rem" }} onClick={goCreateNewCustomer}>
                                                + Crea nuovo cliente
                                            </Button>
                                        </div>
										<AsyncSelect
                                            required
                                            name="playerId"
                                            value={selectedUser}
                                            onChange={handleUserSelect}
                                            onInputChange={(value, meta) => { if (meta.action === 'input-change') setUserSearchInput(value); }}
                                            loadOptions={loadUserOptions}
                                            placeholder="Inizia a digitare per cercare un utente (minimo 3 caratteri)..."
                                            noOptionsMessage={({ inputValue }) => 
                                                inputValue.length < 3 
                                                    ? "Digita almeno 3 caratteri per iniziare la ricerca" 
                                                    : "Nessun utente trovato"
                                            }
                                            loadingMessage={() => "Ricerca in corso..."}
                                            isClearable
                                            cacheOptions
                                            defaultOptions={false}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    minHeight: "38px",
                                                    height: "38px",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "0.375rem",
                                                    fontSize: "0.9rem",
                                                    lineHeight: "1.5"
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: "36px",
                                                    padding: "0 8px"
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    margin: "0",
                                                    paddingTop: "0",
                                                    paddingBottom: "0"
                                                }),
                                                indicatorsContainer: (provided) => ({
                                                    ...provided,
                                                    height: "36px"
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: "#6c757d",
                                                    fontSize: "0.9rem"
                                                })
                                            }}
                                        />
									</Col>
								</Row>
                                <Row className="mt-4">
                                    <Col className="col-lg-6">
                                        <Form.Label>Tipologia di corso *</Form.Label>
                                        <Select
                                            placeholder="Seleziona una tipologia..."
                                            required
                                            name="course_id" 
                                            value={courses.find(option => option.value === formData.course_id)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "course_id")}
                                            options={courses}
                                            style={{lineHeight: "40px", color: "#fd7e14", paddingLeft: " 15px"}}
                                        />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Sport</Form.Label>
                                        <Select
                                            placeholder=""
                                            isDisabled={true}
                                            name="sportType" 
                                            value={sports.find(option => option.value === formData.sportType)}
                                            options={sports}
                                            style={{
                                                lineHeight: "40px",
                                                color: "#fd7e14",
                                                paddingLeft: " 15px",
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-lg-6">
                                        <Form.Label>Data di inizio</Form.Label>
                                        <Form.Control disabled className="mt-2" type="text" name="dateStart" value={formData.dateStart} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                    </Col>
                                    <Col className="col-lg-6">
                                        <Form.Label>Data di fine</Form.Label>
                                        <Form.Control disabled className="mt-2" type="text" name="dateEnd" value={formData.dateEnd} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Corso per junior</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={isForJunior}
                                        onChange={handleCheckboxChange}
                                        />
                                        &nbsp;&nbsp;&nbsp;Questo corso viene acquistato per uno junior
                                    </label>
                                </Row>

                                {isForJunior && (
                                    <>
                                        {formData.playerId && (
                                            <div className="mb-2 mt-2">
                                                <Button variant="link" className="p-0" style={{ fontSize: "0.9rem" }} onClick={goCreateNewJunior}>
                                                    + Aggiungi Junior
                                                </Button>
                                            </div>
                                        )}
                                        <div id="junior-lista">
                                        {juniors && juniors.length > 0 ? (
                                            <TabellaLista
                                                cardTitle={'Lista Juniors'}
                                                hasSearch={false}
                                                hasFilter={false}
                                                data_column={juniors_data_column}
                                                data_json={juniors}
                                                hasAddMoreAsModal={false}
                                            />
                                        ) : (
                                            <p className="text-muted mt-2">Nessun junior collegato a questo cliente. Usa "+ Aggiungi Junior" per crearne uno.</p>
                                        )}
                                        </div>
                                    </>
                                )}
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" className="btn btn-dark light" onClick={() => goBack(-1)}>Annulla</button>
                        <button type="button" onClick={() => handleSaveClick(1, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'prezzi',
			name: "Prezzi",
			icon: <DollarSquare size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Header><h4 className="card-title">Controlla i prezzi</h4></Card.Header>
                        <Card.Body>
                            <Form ref={el => formRefs.current[1] = el} noValidate>
                                <Row className="mt-4">
                                    <Col className="col-lg-6">
										<Form.Label>Destinatario corso</Form.Label>
										<Form.Control disabled className="mt-2" type="text" name="corso_user" value={formData.corso_user_junior?formData.corso_user_junior:formData.corso_user} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
									</Col>
                                    <Col className="col-lg-6">
										<Form.Label>Prezzo</Form.Label>
										<Form.Control className="mt-2" type="number" min="0" step="0.01" name="prezzo_praticato" value={formData.prezzo_praticato} onChange={(e) => setFormData(prev => ({ ...prev, prezzo_praticato: e.target.value }))} />
                                        {formData.prezzo_praticato !== '' && numeroDaTesto(formData.prezzo_praticato) !== numeroDaTesto(String(formData.course_price).replace(' €', '')) && (
                                            <small className="text-muted">Prezzo di listino: {formData.course_price}</small>
                                        )}
									</Col>
								</Row>
                                {(showingSociOptions || showingTesseratiOptions) && <Row className="mt-4">
                                    {showingSociOptions && (
                                    <Col className="col-lg-6">
										<Form.Label>Utente socio</Form.Label>
										<Form.Control disabled className="mt-2" type="text" name="member_price" value={formData.isMember} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
									</Col>
                                    )}
                                    {showingTesseratiOptions && (
                                    <Col className="col-lg-6">
										<Form.Label>Utente tesserato</Form.Label>
										<Form.Control disabled className="mt-2" type="text" name="federated_price" value={formData.isFederated} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
									</Col>
                                    )}
                                </Row> }
                                <Row className="mt-4">
                                    <Col className="col-lg-6">
										<Form.Label>Data di inizio</Form.Label>
										<Form.Control disabled className="mt-2" type="text" name="dateStart" value={formData.dateStart} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
									</Col>
                                    <Col className="col-lg-6">
										<Form.Label>Data di fine</Form.Label>
										<Form.Control disabled className="mt-2" type="text" name="dateEnd" value={formData.dateEnd} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
									</Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(0)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleSaveClick(2, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'fatturazione_pagamento',
			name: "Fatturazione e pagamento",
			icon: <CardAdd size='18' />,
			content: (
				<>
                    <Form ref={el => formRefs.current[2] = el} noValidate>
                        <Card>
                            <Card.Header><h4 className="card-title">Dati di fatturazione</h4></Card.Header>
                            <Card.Body>        
                                <Row className="mt-4">
                                    {/* Selezione Tipo Cliente */}
                                    <Col md={12}>
                                        <Form.Label>Tipo Cliente *</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="tipo_cliente"
                                            value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                            options={optionsFatturazione}
                                        />
                                    </Col>
                                </Row>

                                {/* Azienda */}
                                {formData.tipo_cliente === 'azienda' && (
                                    <Row className="mt-4">
                                        <Col lg={4}>
                                            <Form.Label>Ragione sociale</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="ragione_sociale"
                                                value={formData.ragione_sociale}
                                                onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Partita IVA</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="partita_iva"
                                                value={formData.partita_iva}
                                                onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={4}>
                                            <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="codice_destinatario"
                                                value={formData.codice_destinatario}
                                                onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Privato */}
                                {formData.tipo_cliente === 'privato' && (
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label>Nome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="nome"
                                                value={formData.nome}
                                                onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Label>Cognome</Form.Label>
                                            <Form.Control
                                                required
                                                className="mt-2"
                                                type="text"
                                                name="cognome"
                                                value={formData.cognome}
                                                onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                {/* Campi comuni */}
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Codice Fiscale</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="codice_fiscale"
                                            value={formData.codice_fiscale}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Email PEC / Email</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Indirizzo</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="indirizzo"
                                            value={formData.indirizzo}
                                            onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="cap"
                                            value={formData.cap}
                                            onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={3}>
                                        <Form.Label>Città</Form.Label>
                                        <Form.Control
                                            required
                                            className="mt-2"
                                            type="text"
                                            name="citta"
                                            value={formData.citta}
                                            onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Provincia *</Form.Label>
                                        <Select
                                            required
                                            className="mt-2"
                                            name="provincia"
                                            value={italianProvinces.find(option => option.value === formData.provincia)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                            options={italianProvinces}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Nazione</Form.Label>
                                        <Form.Control
                                            required
                                            readOnly
                                            className="mt-2"
                                            type="text"
                                            name="nazione"
                                            value="Italia"
                                            onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Header><h4 className="card-title">Dati di pagamento</h4></Card.Header>
                            <Card.Body>        
                                <Row className="mt-4">
                                    <Col md={6}>
                                        <Form.Label>Pagato</Form.Label>
                                        <Select
                                            className="mt-2"
                                            name="is_pagato"
                                            value={optionsBoolean.find(option => option.value === formData.is_pagato)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "is_pagato")} 
                                            options={optionsBoolean}
                                        />
                                    </Col>
                                    {formData.is_pagato && (
                                        <Col md={6}>
                                            <Form.Label>Genera documento</Form.Label>
                                            <Select
                                                isDisabled={!isFatturazioneConfirmed}
                                                className="mt-2"
                                                name="skip_generate_document"
                                                value={optionsGenerateDocument.find(option => option.value === formData.skip_generate_document)}
                                                onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")} 
                                                options={optionsGenerateDocument}
                                            />
                                        </Col>
                                    )}
                                </Row>
                                <Row className="mt-4">
                                    {formData.is_pagato && ( <Col md={6}>
                                        <Form.Label>Modalità di pagamento</Form.Label>
                                        <Select
                                            className="mt-2"
                                            name="modalita_pagamento"
                                            value={optionsPayment.find(option => option.value === formData.modalita_pagamento)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
                                            options={optionsPayment}
                                        />
                                    </Col> )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </Form>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(1)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleSaveClick(3, 'DRAFT')} className="btn btn-primary ">Avanti</button>
                    </div>
                </>
			),
		},
		{
			id: 'riepilogo',
			name: "Riepilogo e conferma",
			icon: <Judge size='18' />,
			content: (
				<>
                    <Card>
                        <Card.Header><h4 className="card-title">Riepilogo e conferma</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Corso</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="course_name	" value={formData.course_name	} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Sport</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="sportType" value={sports.find(o => o.value === formData.sportType)?.label || formData.sportType} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Cliente</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="corso_user" value={formData.corso_user} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                {formData.corso_user_junior && (
                                    <Col className="col-lg-6">
                                        <Form.Label>Junior</Form.Label>
                                        <Form.Control disabled className="mt-2" type="text" name="juniorName" value={formData.corso_user_junior} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                    </Col>
                                )}
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Data di inizio</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="dateStart" value={formData.dateStart} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Data di fine</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="dateEnd" value={formData.dateEnd} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Prezzo</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="price" value={formData.prezzo_praticato + ' €'} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Dati di fatturazione</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                {/* Selezione Tipo Cliente */}
                                <Col md={12}>
                                    <Form.Label>Tipo Cliente</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="tipo_cliente_2"
                                        value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                        options={optionsFatturazione}
                                    />
                                </Col>
                            </Row>
                            {/* Azienda */}
                            {formData.tipo_cliente === 'azienda' && (
                                <Row className="mt-4">
                                    <Col lg={4}>
                                        <Form.Label>Ragione sociale</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="ragione_sociale"
                                            value={formData.ragione_sociale}
                                            onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Partita IVA</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="partita_iva"
                                            value={formData.partita_iva}
                                            onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="codice_destinatario"
                                            value={formData.codice_destinatario}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}

                            {/* Privato */}
                            {formData.tipo_cliente === 'privato' && (
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="nome"
                                            value={formData.nome}
                                            onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Cognome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="cognome"
                                            value={formData.cognome}
                                            onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}

                            {/* Campi comuni */}
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Codice Fiscale</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="codice_fiscale"
                                        value={formData.codice_fiscale}
                                        onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Email PEC / Email</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Indirizzo</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="indirizzo"
                                        value={formData.indirizzo}
                                        onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>CAP</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="cap"
                                        value={formData.cap}
                                        onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>Città</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="citta"
                                        value={formData.citta}
                                        onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Provincia</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="provincia"
                                        value={italianProvinces.find(option => option.value === formData.provincia)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                        options={italianProvinces}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Nazione</Form.Label>
                                    <Form.Control
                                        required
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="nazione"
                                        value="Italia"
                                        onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Dati di pagamento</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>Pagato</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="is_pagato"
                                        value={optionsBoolean.find(option => option.value === formData.is_pagato)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "is_pagato")} 
                                        options={optionsBoolean}
                                    />
                                </Col>
                                {formData.is_pagato && (
                                    <Col md={6}>
                                        <Form.Label>Genera documento</Form.Label>
                                        <Select
                                            isDisabled
                                            className="mt-2"
                                            name="skip_generate_document"
                                            value={optionsGenerateDocument.find(option => option.value === formData.skip_generate_document)}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")} 
                                            options={optionsGenerateDocument}
                                        />
                                    </Col>
                                )}
                            </Row>
                            <Row className="mt-4">
                                {formData.is_pagato && ( <Col md={6}>
                                    <Form.Label>Modalità di pagamento</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="modalita_pagamento"
                                        value={optionsPayment.find(option => option.value === formData.modalita_pagamento)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
                                        options={optionsPayment}
                                    />
                                </Col> )}
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Consensi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Row>
                                    <label>
                                        <input
                                        id="accetta-termini"
                                        type="checkbox"
                                        checked={termsAndConditions}
                                        onChange={handleCheckboxChangeTermsAndConditions}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Il cliente accetta <a style={{ color: 'var(--primary)' }} target="_blank" href="https://sportid.it/termini-e-condizioni/strutture-e-player/" rel="noreferrer">termini e condizioni della struttura</a> *</b>
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsMarketing}
                                        onChange={handleCheckboxChangeTermsAndConditionsMarketing}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Attività di marketing</b><br></br>
                                        Autorizzo il centro sportivo a inviarmi comunicazioni promozionali relative a eventi, corsi, 
                                        offerte e iniziative tramite email, SMS o altri canali.
                                    </label>
                                </Row>
                                <Row>
                                    <label>
                                        <input
                                        type="checkbox"
                                        checked={termsAndConditionsImage}
                                        onChange={handleCheckboxChangeTermsAndConditionsImage}
                                        />
                                        &nbsp;&nbsp;&nbsp;<b>Uso dell'immagine</b><br></br>
                                        Autorizzo il centro sportivo all’utilizzo di foto e video in cui potrei comparire, realizzati durante le attività, 
                                        per finalità informative, promozionali e di comunicazione sui canali ufficiali (sito web, social media, materiali informativi), 
                                        nel rispetto della normativa sulla privacy (Reg. UE 2016/679 - GDPR).
                                    </label>
                                </Row>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end gap-4 mt-4">
                        <button type="button" onClick={() => goBack(2)} className="btn btn-dark light">Indietro</button>
                        <button type="button" onClick={() => handleSaveClick(4, 'PURCHASABLE')} className="btn btn-primary ">Conferma</button>
                    </div>
                </>
			),
		}
	];

	return (
		<>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<div className="custom-tab-1">
                <Tab.Container activeKey={tabData[tabIndex]?.id.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link onClick={(e) => e.preventDefault()} eventKey={data.id.toLowerCase()} style={{ cursor: 'default', pointerEvents: 'none' }}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-12">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
					</Row>
				</Tab.Container>
			</div>

		</>
	)

}
export default UserCoursesNew;